module.exports = __webpack_public_path__ + "img/team-grey.02380760.svg";